// extracted by mini-css-extract-plugin
export default {"header":"index_header_rdaHP clearfix","logo":"index_logo_B-yrI"};